import { queryOptions, useQuery } from '@tanstack/react-query';

import { DboRegistrationScriptPayload } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';

const DBO_REGISTRATION_SCRIPT_QUERY_KEY = 'dbo-registration-script';

const getDboRegistrationScriptQueryKey = (
  payload?: DboRegistrationScriptPayload
) => [DBO_REGISTRATION_SCRIPT_QUERY_KEY, JSON.stringify(payload)] as const;

type DboRegistrationScriptQueryArgs = {
  payload: DboRegistrationScriptPayload;
  enabled?: boolean;
};

const getDboRegistrationScriptQueryOptions = ({
  payload,
  enabled = true,
}: DboRegistrationScriptQueryArgs) =>
  queryOptions({
    queryKey: getDboRegistrationScriptQueryKey(payload),
    queryFn: () =>
      apiClient.dbo
        .createRegistration({
          registration: payload,
        })
        .then(({ data }) => data),
    refetchOnMount: 'always',
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: enabled && Object.values(payload).some(Boolean),
  });

export const useDboRegistrationScriptQuery = ({
  payload,
  enabled,
}: DboRegistrationScriptQueryArgs) => {
  return useQuery(getDboRegistrationScriptQueryOptions({ payload, enabled }));
};
